import React, { useState } from 'react'
import { Button, Modal, Checkbox, Form, Input } from 'antd'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import { saveUser } from '../../redux/slices/userSlice'
import { useDispatch } from 'react-redux'
import ForgotPassword from './forgotpassword'
import LegacyUser from './legacyUser'
import MmaPopup from './mmapopup'

const LoginModal = ({ isOpen, onClose, notClosable }) => {
  const handleOk = () => {
    onClose()
  }

  const handleCancel = () => {
    onClose()
  }

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [error, setError] = useState(null)
  const [isLoading, setIsLoading] = useState(false) // Add loading state
  const [isForgotModalOpen, setForgotModalOpen] = useState(false)
  const [isMmaPopupOpen, setMmaPopupOpen] = useState(false)
  const [isLegacyModalOpen, setLegacyModalOpen] = useState(false)
  const [email, setEmail] = useState('') // Add state for email
  const [form] = Form.useForm() // Ant Design form instance
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  })

  const handleChange = (e, fieldName) => {
    setFormData({
      ...formData,
      [fieldName]: e.target.value
    })
  }

  const handleSubmit = async () => {
    console.log('LOGIN MODAL')
    setIsLoading(true)

    try {
      const response = await axios.post('/api/auth/login', formData, {
        headers: {
          'Content-Type': 'application/json'
        }
      })

      console.log('LOGIN RESPONSE:', response.data)

      // navigate("/home");
      if (response.data.user.legacy && !response.data.user.verified) {
        // Open the LegacyUser modal
        setLegacyModalOpen(true)
        setEmail(response.data.user.email)
        setIsLoading(false)
        handleCancel()
      } else {
        // Navigate to home if not a legacy user with unverified status
        dispatch(saveUser(response.data))

        console.log(
          'needMmaLogin:',
          response.data.needMmaLogin
        )

        if (response.data.needMmaLogin && !localStorage.getItem('hideMmaPopup')) {
          setIsLoading(false)
          handleCancel()
          setMmaPopupOpen(true)
        } else {
          window.location.href = '/home'
        }
      }

      // console.log(response.data)
    } catch (error) {
      setIsLoading(false)
      console.error('Error submitting form:', error)
      setError(error.response?.data.error || 'An error occurred')
    }
  }

  return (
    <div>
      <Modal
        title="Please Login"
        open={isOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        width={700}
        centered
        closable={notClosable ? false : true} // Hides the close (X) button
        maskClosable={notClosable ? false : true} // Prevents closing by clicking on the background
      >
        <div>
          <div
            style={{
              borderBottom: '1px solid #ddd',
              marginBottom: '15px',
              marginTop: '30px'
            }}
          ></div>

          <Form
            name="basic"
            style={{
              // maxWidth: 600,
              margin: 'auto', // Center horizontally
              marginTop: '50px', // Adjust the top margin to center vertically
              paddingLeft: '10%',
              paddingRight: '10%'
            }}
            initialValues={{
              remember: true
            }}
            onFinish={handleSubmit}
            autoComplete="off"
            form={form}
          >
            {error && (
              <div
                style={{
                  color: 'red',
                  marginBottom: '10px',
                  textAlign: 'center'
                }}
              >
                {error}
              </div>
            )}
            <Form.Item
              name="username"
              rules={[
                {
                  required: true,
                  message: 'Please input your username!'
                }
              ]}
            >
              <Input
                className="bottom-border-input"
                placeholder="*Username"
                value={formData.username}
                onChange={e => handleChange(e, 'username')}
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: 'Please input your password!'
                }
              ]}
            >
              <Input.Password
                className="bottom-border-input"
                placeholder="*Password"
                value={formData.password}
                onChange={e => handleChange(e, 'password')}
              />
            </Form.Item>

            <Form.Item name="remember" valuePropName="checked">
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Checkbox>Remember me</Checkbox>
                <a
                  onClick={() => {
                    onClose()
                    setForgotModalOpen(true)
                  }}
                  style={{ cursor: 'pointer', color: '#703895' }}
                >
                  Lost your password
                </a>
              </div>
            </Form.Item>

            <Form.Item>
              <div style={{ textAlign: 'center' }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isLoading} // Use the loading prop to show/hide the loader
                  style={{
                    background: 'transparent',
                    color: '#703895',
                    border: '2px solid #703895',
                    width: '200px'
                  }}
                >
                  Login
                </Button>
              </div>
            </Form.Item>

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <p style={{ margin: 0, color: 'gray' }}>
                Don't have an account?{' '}
              </p>
              <span
                onClick={() => navigate('/register')}
                style={{
                  cursor: 'pointer',
                  marginLeft: '5px',
                  color: '#703895'
                }}
              >
                {' '}
                SIGNUP
              </span>
            </div>
          </Form>
        </div>
      </Modal>
      <ForgotPassword
        isOpen={isForgotModalOpen}
        onClose={() => setForgotModalOpen(false)}
      />
      <LegacyUser
        isOpen={isLegacyModalOpen}
        onClose={() => setLegacyModalOpen(false)}
        userEmail={email}
      />

      <MmaPopup
        isOpen={isMmaPopupOpen}
        onClose={() => setMmaPopupOpen(false)}
        onYes={() => {
          window.location.href = process.env.REACT_APP_MMA_LOGIN
        }}
        onNo={() => {
          setMmaPopupOpen(false)
          window.location.href = '/home'
        }}
      />
    </div>
  )
}
export default LoginModal
